// extracted by mini-css-extract-plugin
export default {"collection":"SectionListingCollection_collection__67tPp"};